import { gql } from '@apollo/client';

export const PARTNER_TYPES_QUERY = gql`
  query partnerTypes {
    partnerTypes {
      id
      name
      code
      baseTypes {
        id
        code
        name
        isSelected
      }
      properties {
        partnerTypeId
        propertyId
        propertyName
        propertyTypeCode
        defaultValue
        mandatory
      }
    }
  }
`;
